import * as React from 'react';
import { WizardProps } from '../../components-v2/Wizard';
import SisFieldMatching from './index';
import {
  defaultNavStaffOneRosterMapping,
  navianceStaffOneRosterFields,
  oneRosterCustomHeaders,
} from '../../utils/fieldMapUtils';
import SisMatchDescriptionHeader from '../../components-v2/SisMatchDescriptionHeader';
import SisWizardHeader from '../../components-v2/SisWizardHeader';
import axios from 'axios';
import { getOneRosterFileApiBaseUrl } from '../../utils/constants';
import { NotificationTypes, showNotification } from '../../components/Notifications';

const OneRosterStaffRecordsMatching = (props: WizardProps): React.ReactElement => {
  const [sections, setSections] = React.useState([
    {
      tableHeader: <SisWizardHeader text={'Staff records'} />,
      defaultFields: navianceStaffOneRosterFields([]),
      defaultBlankValue: '(Do not import)',
    },
  ]);

  const fetchOneRosterMeta = async () => {
    try {
      const res = await axios.get(`${getOneRosterFileApiBaseUrl()}/oneroster/job/latest/status`, {
        withCredentials: true,
      });
      let dataJsonFile: string;
      if (res.data.status === 'COMPLETED') {
        dataJsonFile = res.data.presignedUrl;
      }
      const response = await axios.get(dataJsonFile);
      setSections([{ ...sections[0], defaultFields: navianceStaffOneRosterFields(response.data?.staff?.meta || []) }]);
    } catch (error) {
      showNotification(NotificationTypes.error, 'Error Getting metadata', 'Failure in getting data from server.');
    }
  };

  React.useEffect(() => {
    fetchOneRosterMeta();
  }, []);

  return (
    <SisFieldMatching
      defaultMapping={defaultNavStaffOneRosterMapping}
      specificMapping={{ ...oneRosterCustomHeaders }}
      allFieldsRequired={false}
      mustMapRequiredFields={true}
      translateConfigEndPoint={'data-ingest/sis/parameter-group/staff-recordstranslateConfig'}
      // extensionsEndpoint={''}
      removeUnmappedHeaders={false}
      removeEmptyHeaders={false}
      sections={sections}
      header={<SisMatchDescriptionHeader />}
      {...props}
    />
  );
};

export default OneRosterStaffRecordsMatching;
